var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('notifications',{attrs:{"group":"foo"}}),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row-fluid"},[_c('hello')],1),_c('div',{staticClass:"span10"},[_c('list')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }